var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import Slider from 'wix-style-react/dist/es/src/Slider';
import { TPAComponentsContext } from '../TPAComponentsConfig';
import { st, classes } from './Range.st.css';
import { RangeDataHooks } from './types';
import { ErrorMessageWrapper } from '../internal/ErrorMessageWrapper';
var uniqueId = require('lodash/uniqueId');
var formatValue = function (value, format) {
    var _a = format !== null && format !== void 0 ? format : {}, _b = _a.locale, locale = _b === void 0 ? 'en' : _b, formatOptions = __rest(_a, ["locale"]);
    return Intl.NumberFormat(locale, formatOptions).format(value);
};
export var Range = function (_a) {
    var _b;
    var value = _a.value, _c = _a.min, min = _c === void 0 ? 0 : _c, max = _a.max, format = _a.format, label = _a.label, disabled = _a.disabled, minAriaLabel = _a.minAriaLabel, maxAriaLabel = _a.maxAriaLabel, onChange = _a.onChange, onAfterChange = _a.onAfterChange, errorMessage = _a.errorMessage, other = __rest(_a, ["value", "min", "max", "format", "label", "disabled", "minAriaLabel", "maxAriaLabel", "onChange", "onAfterChange", "errorMessage"]);
    var sliderId = React.useMemo(function () { return uniqueId('slider-id_'); }, []);
    var errorMessageId = React.useMemo(function () { return uniqueId('error-message'); }, []);
    var rtl = React.useContext(TPAComponentsContext).rtl;
    var changeHandler = React.useCallback(function (range) {
        onChange && onChange(range);
    }, [onChange]);
    var stStates = { error: !!errorMessage };
    return (React.createElement(ErrorMessageWrapper, __assign({}, (_b = {
            visible: !!errorMessage,
            message: errorMessage,
            messageId: errorMessageId,
            className: st(classes.root, stStates, other.className)
        },
        _b['data-hook'] = other['data-hook'],
        _b)),
        React.createElement("fieldset", { className: classes.container },
            label && (React.createElement("legend", { "data-hook": RangeDataHooks.Label, className: classes.label }, label)),
            React.createElement("div", { className: classes.sliderWrapper },
                React.createElement(Slider, { id: sliderId, className: st(classes.slider, { rtl: rtl }), onChange: changeHandler, onAfterChange: onAfterChange, min: min, max: max, value: value || [min, max], displayMarks: false, disabled: disabled, displayTooltip: false, rtl: rtl, ariaLabelForHandle: [minAriaLabel, maxAriaLabel] })),
            React.createElement("div", { className: classes.rangeValues },
                React.createElement("span", { "data-hook": RangeDataHooks.SelectedMinValue }, formatValue(value ? value[0] : min, format)),
                React.createElement("span", { "data-hook": RangeDataHooks.SelectedMaxValue }, formatValue(value ? value[1] : max, format))))));
};
Range.displayName = 'Range';
//# sourceMappingURL=Range.js.map